export default __webpack_public_path__ + "static/media/orange beanie.a76f720b.png";